import styled from '@emotion/styled';
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    mediaQuery,
    zIndexes,
} from '@gumtree/ui-library/src/base/theme';

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: ${zIndexes.high};
    display: flex;
    align-items: center;
    justify-content: center;

    ${mediaQuery.until(breakpoints.medium)} {
        align-items: flex-end;
    }
`;

export const ModalContainer = styled.div`
    background: ${colors.white};
    border-radius: 8px;
    width: 420px;
    padding: 40px ${gutterSizes.xxlarge} ${gutterSizes.xlarge};
    position: relative;
    box-sizing: border-box;
    text-align: center;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 56px 16px 32px;
        text-align: left;
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: ${gutterSizes.large};
    background: none;
    border: none;
    cursor: pointer;
    padding: ${gutterSizes.small};
    line-height: 1;
    font-size: 20px;
    color: ${colors.darkGrey};
    -webkit-tap-highlight-color: transparent;

    &:hover {
        color: ${colors.bark};
    }
`;

export const IllustrationWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: ${gutterSizes.large};

    ${mediaQuery.until(breakpoints.medium)} {
        display: none;
    }
`;

export const ModalTitle = styled.h2`
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.pgLarge};
    color: ${colors.bark};
    margin-top: ${gutterSizes.xlarge};
    margin-bottom: 8px;

    ${mediaQuery.until(breakpoints.medium)} {
        font-size: ${fontSizes.xlarge};
        margin: 0 0 ${gutterSizes.medium};
    }
`;

export const CheckboxWrapper = styled.label`
    display: flex;
    align-items: flex-start;
    gap: ${gutterSizes.medium};
    text-align: left;
    margin-bottom: ${gutterSizes.xlarge};
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
`;

export const HiddenCheckbox = styled.input`
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
`;

export const CustomCheckbox = styled.span<{ checked: boolean }>`
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid ${({ checked }) => (checked ? '#0D475C' : '#8E969C')};
    background-color: ${({ checked }) => (checked ? '#0D475C' : colors.white)};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    margin-top: 3px;

    &::after {
        content: '';
        display: ${({ checked }) => (checked ? 'block' : 'none')};
        width: 5px;
        height: 10px;
        border: solid ${colors.white};
        border-width: 0 2.5px 2.5px 0;
        transform: rotate(45deg) translate(-1px, -1px);
    }
`;

export const CheckboxLabel = styled.span`
    font-size: ${fontSizes.base};
    color: #635B67;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 1%;
`;

export const ConfirmButton = styled.button`
    width: 100%;
    height: 46px;
    border: none;
    border-radius: 4px;
    background-color: ${colors.gtGreen};
    color: #0D475C;
    font-size: ${fontSizes.medium};
    font-weight: ${fontWeights.bold};
    cursor: pointer;
    transition: background-color 0.2s ease;
    -webkit-tap-highlight-color: transparent;

    &:hover {
        background-color: ${colors.newBrandHoverState};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;
